<app-header></app-header>

<section class="container-xxl">
    <!-- BREADCRUMB AREA - STARTS -->
    <div class="breadcrumb-area">
        <nav aria-label="breadcrumb mb-0">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a routerLink="/">Home</a></li>
                <li class="breadcrumb-item active">Sample Content Page</li>

            </ol>
        </nav>
    </div>
    <!-- BREADCRUMB AREA - ENDS -->
    <div class="inner-page">
        <div class="inner-page-details">
            <div class="row">
                <div class="col-lg-2">  
                    <app-website-inner-sidenav></app-website-inner-sidenav>
                </div> 
                <div class="col-lg-10">
                    <div class="inner-page-sidedetails">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="inner-banner-image">
                                    <div class="image-area">
                                        <div class="image-area">
                                            <img src="assets/images/inner-banner.webp" alt="inner-banner-image">
                                        </div>
                                    </div>
                                </div>
                                <div class="details">
                                    <div class="title">
                                        <h2>Sample Content Page</h2>
                                    </div>
                                    <div class="description">
                                        <div class="inner-content">
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <div class="content-details font-adjust ">
                                                        <h3>Procurement Data for Current Marketing Season</h3>
                                                        <ul>
                                                            <li><a href="javascript:;" title="Link">State wise
                                                                    Procurement of Rice during KMS 2022-23 (pdf - 405
                                                                    KB)</a>
                                                            </li>
                                                            <li><a href="javascript:;" title="Link">State wise/Agency
                                                                    wise Procurement of Paddy during KMS 2022-23 (pdf
                                                                    - 416 KB)</a></li>
                                                            <li><a href="javascript:;" title="Link">State wise
                                                                    Procurement of Wheat during RMS 2023-24 (pdf - 411
                                                                    KB)</a>
                                                            </li>
                                                        </ul>

                                                        <h4>Procurement Data for Current Marketing Season</h4>
                                                        <ol>
                                                            <li>State wise Procurement of Rice during KMS 2022-23 (pdf -
                                                                405 KB)
                                                            </li>
                                                            <li>State wise/Agency wise Procurement of Paddy during KMS
                                                                2022-23 (pdf
                                                                - 416 KB)</li>
                                                            <li>State wise Procurement of Wheat during RMS 2023-24 (pdf
                                                                - 411 KB)
                                                            </li>
                                                        </ol>

                                                        <h3 id="overviewTable">Overview</h3>
                                                        <p class="fs-big">The storage function assumes paramount
                                                            importance in
                                                            organization such as Food Corporation of India because of
                                                            its requirement to
                                                            hold huge inventory of foodgrains over a significant period
                                                            of time. Storage
                                                            plan of FCI is primarily to meet the storage requirement for
                                                            holding stocks
                                                            to meet the requirements of Public Distribution System and
                                                            Other Welfare
                                                            Schemes undertaken by the Government of India. Also, buffer
                                                            stock is to be
                                                            maintained for ensuring food security of the nation.
                                                            Adequate scientific
                                                            storage is pre-requisite to fulfill the policy objectives
                                                            assigned to the
                                                            Food Corporation of India for which FCI has a network of
                                                            strategically
                                                            located storage depots including silos all over India.</p>
                                                        <p class="fw-bold">Besides having own storage capacity, FCI has
                                                            hired storage
                                                            capacities from Central Warehousing Corporation, State
                                                            Warehousing
                                                            Corporations, State Agencies and Private Parties for short
                                                            term as well as
                                                            for guaranteed period under Private Entrepreneurs Guarantee
                                                            Scheme.</p>
                                                        <p>New Godowns are being constructed by FCI mainly through
                                                            Private Participation
                                                            under Private Entrepreneurs Guarantee Scheme. FCI is also
                                                            augmenting and
                                                            modernizing its storage capacity in the form of silos
                                                            through Public Private
                                                            Partnership.</p>
                                                        <p>Storage Capacity for Central Pool Stocks for the last ten
                                                            Years as on 1st
                                                            April is given as under:</p>
                                                        <table class="table table-sm" aria-describedby="overviewTable">
                                                            <thead>
                                                                <th>As On</th>
                                                                <th>Storage Capacity with FCI</th>
                                                                <th>Storage Capacity with State Agencies</th>
                                                                <th>Total</th>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>01-04-2012</td>
                                                                    <td>336.04</td>
                                                                    <td>336.04</td>
                                                                    <td>677.39</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>01-04-2012</td>
                                                                    <td>336.04</td>
                                                                    <td>336.04</td>
                                                                    <td>677.39</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>01-04-2012</td>
                                                                    <td>336.04</td>
                                                                    <td>336.04</td>
                                                                    <td>677.39</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>01-04-2012</td>
                                                                    <td>336.04</td>
                                                                    <td>336.04</td>
                                                                    <td>677.39</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>

                                                        <h3>Procurement</h3>
                                                        <h5>Policy and System</h5>
                                                        <p>The Central Government extends price support to wheat and
                                                            paddy through FCI and State Agencies. Procurement at MSP is
                                                            open ended i.e., whatever foodgrains are offered by the
                                                            farmers ,within the stipulated procurement period and which
                                                            conforms to the quality specifications prescribed by
                                                            Government of India, are purchased at MSP (and
                                                            bonus/incentive ,if any) by the Government agencies
                                                            including FCI for central Pool. Some States also declare
                                                            State bonus on wheat and paddy over and above MSP.</p>
                                                        <p>Government agencies undertake MSP operation at mandis/
                                                            temporary purchase centres/aggregation points. Location and
                                                            number of purchase centres to be opened are decided in
                                                            consultation with /by the State governments.</p>

                                                        <h6>Systems of procurement :</h6>
                                                        <p><b>1.Wheat</b> - FCI undertakes procurement directly and
                                                            jointly with SGAs in non-DCP states. In the major procuring
                                                            states like Punjab, MP and Haryana, wheat is mainly procured
                                                            by state agencies and they preserve the stocks under their
                                                            custody for which carry –over charges are paid to them. FCI
                                                            takes over the stocks for dispatching to other consuming
                                                            states as per requirement /movement plan. Payments are made
                                                            to State Govt. /agencies as per Provisional cost sheets
                                                            issued by GOI after taking over the stocks. In the states
                                                            like UP and Rajasthan, the wheat procured by state agencies
                                                            is immediately taken over by FCI.</p>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<app-clients></app-clients>

<app-footer></app-footer>